module.exports = __webpack_public_path__ + "static/img/装饰10.9ebadbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰10.svg
// module id = 190f
// module chunks = 2